import React from 'react';
import { useParams } from 'react-router-dom';
import TrailCertificateTable from 'views/Certificate/TrailCertificateTable';

const TrailCertificates = () => {
  const { id } = useParams();

  return <TrailCertificateTable id_user={id} />;
};

export default React.memo(TrailCertificates);
